// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3-Fx_","title":"Info_title__1UQjb","selects":"Info_selects__38J4K","requiredAsterisk":"Info_requiredAsterisk__4eB3n"};